/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AttachmentDto } from '../model/attachment-dto.model';
import { tap } from 'rxjs/operators';
import { EnvironmentService } from '@irian-ro/util-environment';

@Injectable()
export class AttachmentsService {
  url: string | undefined = undefined;

  constructor(private readonly httpClient: HttpClient, private readonly environmentService: EnvironmentService) {
    this.url = this.environmentService.getEnvironmentProperty('baseUrl') + '/attachment';
  }

  uploadFile(file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.httpClient.post(this.url + '/uploadFile', formData);
  }

  uploadMultipleFiles(files: File[]): Observable<any> {
    const formData: FormData = new FormData();
    files.forEach((file) => formData.append('files', file));
    return this.httpClient.post(this.url + '/uploadMultipleFiles', formData);
  }

  downloadFile(attachment: AttachmentDto) {
    return this.httpClient
      .get(this.url + '/downloadFile/' + attachment.uuid, {
        responseType: 'arraybuffer',
      })
      .pipe(tap((res) => this.download(res, attachment.fileType)));
  }

  deleteFile(uuid: string) {
    return this.httpClient.delete(this.url + `/${uuid}`).pipe(tap((res) => console.log(res)));
  }

  private download(data: any, fileType: any) {
    const blob = new Blob([data], { type: fileType });
    const url = window.URL?.createObjectURL(blob);
    window.open(url);
  }
}
